import { API } from "../../utils/api";

export const getGlobalData = async () => {
  const res = await API.get(`boot`);
  return res.data.data;
};
